import Pagination from "@mui/material/Pagination";
import moment from "moment";
import { useEffect, useRef } from "react";

import EmptyList from "components/EmptyList";
import ListCardSkeleton from "components/ListCardSkeleton";
import { useProfessionalQuote } from "providers/Quote/ProfessionalQuote";

import ProfessionalQuoteReportCard from "../ProfessionalQuoteReportCard";

const ProfessionalQuoteReportList = () => {
  const professionalQuotesReportRef = useRef<HTMLDivElement>(null);
  const professionalQuotesReportListRef = useRef<HTMLDivElement>(null);

  const {
    professionalConcludedQuotes,
    professionalConcludedQuotesTotalPages,
    professionalConcludedQuotesCurrentPage,
    isLoadingProfessionalConcludedQuotes,
    reportSearchData,
    fetchProfessionalConcludedQuotes,
    setProfessionalConcludedQuotesCurrentPage,
  } = useProfessionalQuote();

  const handlePagination = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setProfessionalConcludedQuotesCurrentPage(value);

    professionalQuotesReportRef.current?.scrollIntoView({
      behavior: "smooth",
    });
  };

  useEffect(() => {
    fetchProfessionalConcludedQuotes(1);
  }, [reportSearchData]);

  return (
    <>
      {!!reportSearchData.beginDate && !!reportSearchData.endDate && (
        <div className="bg-white shadow-sm p-3 rounded-xl mb-3 small">
          <i className="uil uil-calendar-alt me-1" aria-hidden="true" />
          Período: {moment(reportSearchData.beginDate).format("DD/MM/YYYY")}{" "}
          a {moment(reportSearchData.endDate).format("DD/MM/YYYY")}
        </div>
      )}

      {!!isLoadingProfessionalConcludedQuotes &&
        [...Array(3)].map((_, index) => <ListCardSkeleton key={index} />)}

      {!isLoadingProfessionalConcludedQuotes && (
        <div ref={professionalQuotesReportListRef}>
          {professionalConcludedQuotes.length > 0 ? (
            professionalConcludedQuotes.map((quote) => (
              <ProfessionalQuoteReportCard key={quote.id} quote={quote} />
            ))
          ) : (
            <EmptyList
              icon="uil-bill"
              title="Nenhum orçamento concluído encontrado"
              subtitle="Ajuste o período ou os filtros para encontrar o que procura"
            />
          )}
        </div>
      )}

      {professionalConcludedQuotesTotalPages > 1 && (
        <Pagination
          color="primary"
          size="large"
          hidePrevButton
          hideNextButton
          count={professionalConcludedQuotesTotalPages}
          page={professionalConcludedQuotesCurrentPage}
          onChange={handlePagination}
          className="mt-4 d-flex justify-content-center"
        />
      )}
    </>
  );
};

export default ProfessionalQuoteReportList;
